module.exports = __webpack_public_path__ + "static/img/oa_shop.d00bb02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oa_shop.png
// module id = 311
// module chunks = 1